// extracted by mini-css-extract-plugin
module.exports = {"settingsLink":"settings-link-module--settingsLink--29A1j"};